import { render } from "./fees.vue?vue&type=template&id=23358d1c&scoped=true"
import script from "./fees.vue?vue&type=script&lang=js"
export * from "./fees.vue?vue&type=script&lang=js"

import "./fees.vue?vue&type=style&index=0&id=23358d1c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23358d1c"]])

export default __exports__